/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactusContent } from '../../models/contactus-content';

export interface ApiMasterContactusContentGetByIdGet$Params {
  id?: string;
}

export function apiMasterContactusContentGetByIdGet(http: HttpClient, rootUrl: string, params?: ApiMasterContactusContentGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ContactusContent>> {
  const rb = new RequestBuilder(rootUrl, apiMasterContactusContentGetByIdGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContactusContent>;
    })
  );
}

apiMasterContactusContentGetByIdGet.PATH = '/api/Master/ContactusContent/GetById';
